import React from "react";
import {Link} from "react-router-dom";
import {Input, Button, Icon} from "../../components";

import {Globals, Constants} from "../../utils";
import {Auth, Sidebar} from "../../services";
import Logo from "../../assets/img/logo.png";

import {connect} from "react-redux";

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
      showPass: false,
      form: {
        email: "",
        password: "",
        terms: false,
        web: true,
      },
    };
  }

  componentDidMount() {
    const {user} = this.props;

    if (!user) {
      return;
    }

    //history.push("/users");
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  /**
   * Event that captures form submission.
   * @param {object} event emitted when submitting the form.
   */

  submit = (emitter) => {
    emitter.preventDefault();

    const {form} = this.state;

    this.setState({submitted: true});

    Auth.authenticate(form)
      .then(({user, token, message}) => {
        if (message !== null) {
          Globals.showWarning(message);
        }

        this.props.dispatch({
          type: "SET_USER",
          payload: user,
        });

        this.props.dispatch({
          type: "SET_ADMIN",
          payload: Globals.setTypeRole(user),
        });

        localStorage.setItem("token", token);

        return user;
      })
      .then((user) => {
        if (!user) {
          return;
        }

        const {level_id: roleId} = user;

        // Sidebar.getModules(roleId)
        //   .then(modules => this.setModules(roleId, user, modules))
        //   .catch(error => console.log({ error: error }))
        //   .finally(() => this.setState({ submitted: false }));

        Sidebar.getModuleByUser(user.id)
          .then((modules) => this.setModules(roleId, user, modules))
          .catch((error) => console.log({error: error}))
          .finally(() => this.setState({submitted: false}));
      })
      .catch((error) => {
        Globals.showError(error?.error);
      })
      .finally(() => this.setState({submitted: false}));
  };

  recoverPass = () => {};

  terms = () => {};

  /**
   * Set the menu depending on the permissions.
   * @param {int} user role identifier.
   * @param {object} object containing user properties.
   * @param {object} object that contains the module properties.
   */

  setModules = (roleId, user, modules) => {
    const {id: userId} = user;

    switch (roleId) {
      case Constants.ROLE_ADMIN:
        this.props.dispatch({
          type: "SET_SIDEBAR",
          payload: modules,
        });

        //this.props.history.push("/users");
        this.props.history.push("/dashboard");

        return;

      case Constants.ROLE_SENIAT:
        this.props.dispatch({
          type: "SET_SIDEBAR",
          payload: modules,
        });
        this.props.history.push("/global-report");
        break;

      case Constants.ROLE_MODERATOR:
      case Constants.ROLE_MANAGER:
        if (modules.length > 0) {
          this.props.dispatch({
            type: "SET_SIDEBAR",
            payload: modules,
          });

          const defaultModule = modules[0]?.path;
          this.props.history.push(defaultModule);

          return;
        } else {
          Globals.showError(
            "No posee módulos asignados, comuníquese con el usuario Administrador",
          );
        }

      default:
      // Sidebar.getModuleByUser(userId).then(response => {
      //   let Menus = [];

      //   const {
      //     modules_seller,
      //     enterprise_modules,
      //     ROLE_SELLER_subuser
      //   } = response;

      //   let array_modules =
      //     roleId === Constants.ROLE_SELLER
      //       ? modules_seller
      //       : enterprise_modules;

      //   if (roleId === Constants.ROLE_MANAGER) {
      //     array_modules = ROLE_SELLER_subuser.role_modules;
      //   }

      //   if (roleId === Constants.ROLE_MANAGER) {
      //     modules.forEach(module => {
      //       const { id } = module;
      //       array_modules.forEach(({ module_id: moduleId }) => {
      //         if (moduleId === id) {
      //           Menus.push(module);
      //         }
      //       });
      //     });
      //   } else {
      //     modules.forEach(module => {
      //       const { id: moduleId } = module;
      //       array_modules.forEach(({ id }) => {
      //         if (id === moduleId) {
      //           Menus.push(module);
      //         }
      //       });
      //     });
      //   }

      //   this.props.dispatch({
      //     type: "SET_SIDEBAR",
      //     payload: Menus
      //   });

      //   this.props.history.push(Menus[0].path);
      // });
    }
  };

  handleDisabled = () => {
    return this.state.form.email === "" || this.state.form.password === "";
  };

  handleChange = ({target}) => {
    const {name, value} = target;

    this.setState((state) => ({
      form: {
        ...state.form,
        [name]: value,
      },
    }));
  };

  render() {
    const {submitted} = this.state;

    return (
      <div id="login">
        <main>
          <div className="left">
            <div className="logo">
              <img src={Logo} alt="Logo" />
            </div>
            <form onSubmit={this.submit}>
              <label>Correo electrónico</label>
              <div className="row">
                <div className="col col-md">
                  <Input
                    value={this.state.email}
                    name="email"
                    onChange={this.handleChange}
                  />
                </div>
              </div>

              <div className="show-pass">
                <label>Contraseña</label>
                <div
                  onClick={() =>
                    this.setState({showPass: !this.state.showPass})
                  }
                >
                  <Icon name="eye" />
                  <span>{this.state.showPass ? "Ocultar" : "Mostrar"}</span>
                </div>
              </div>

              <div className="row">
                <div className="col-md">
                  <Input
                    autoComplete="off"
                    value={this.state.password}
                    type={this.state.showPass ? "text" : "password"}
                    name="password"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="my-3 text-center">
                <Button
                  submitted={submitted ? submitted : undefined}
                  type="submit"
                  color=" "
                  className="primary"
                  block
                  // disabled={this.handleDisabled()}
                >
                  <span style={{fontWeight: "bold", fontSize: "medium"}}>
                    Iniciar Sesión
                  </span>
                </Button>
              </div>
              <div className="link">
                <div>
                  <span>¿No tienes una cuenta? </span>
                  <Link to="/register">
                    <span className="highlighted">Registrarse</span>
                  </Link>
                </div>
                <Link className="highlighted" to="/recover">
                  Olvidé mi contraseña
                </Link>
                <p>Versión 1.0</p>
              </div>
            </form>

            {/* <div className="terms">
              <input type="checkbox" value={form.terms} />
              <span>Acepto los</span>
              <span className="highlighted" onClick={() => this.terms()}>
                Términos y condiciones
              </span>
            </div> */}
          </div>
          <div className="right"></div>
        </main>
        {/* <footer className="copy">
          <p>© 2023 Designed by Limónbyte | All rights reserved</p>
        </footer> */}
      </div>
    );
  }
}

export default connect((state) => {
  return {
    user: state.user,
    admin: state.admin,
  };
})(Login);
